

export default function(to) {
      setTimeout(() => {
        if (to.hash) {
          let element = document.querySelector(to.hash);
          element.scrollIntoView();
        } else {
          return window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }, 500);
    }
